// File: frontend/src/utils/ScrollToTop.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // useLocation hook se current URL ka 'pathname' nikaalein
  const { pathname } = useLocation();

  // Jab bhi 'pathname' (URL) badlega, yeh effect chalega
  useEffect(() => {
    // Page ko scroll karke (x:0, y:0) position par le jaayein
    window.scrollTo(0, 0);
  }, [pathname]); // Yeh effect sirf tab chalega jab 'pathname' badlega

  // Yeh component kuch bhi HTML render nahi karta hai,
  // iska kaam sirf scroll karna hai.
  return null;
};

export default ScrollToTop;